var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "questionnaireEditTableHeader" }, [
      _vm.template.locked || _vm.preview
        ? _c("span", { staticClass: "questionnaireEditTableHeaderText" }, [
            _vm._v(_vm._s(_vm.template.name) + " Table"),
          ])
        : _c("label", { staticClass: "rbCheckbox" }, [
            _c("input", {
              staticClass: "rbCheckboxInput",
              attrs: {
                id: _vm.template.id,
                type: "checkbox",
                name: _vm.template.id,
              },
              domProps: { value: _vm.isSelected },
              on: {
                change: function ($event) {
                  return _vm.onChange($event.target.value)
                },
              },
            }),
            _c(
              "span",
              {
                staticClass: "rbCheckboxLabel questionnaireEditTableHeaderText",
                class: _vm.isSelected,
              },
              [_vm._v(" " + _vm._s(_vm.template.name) + " Table ")]
            ),
          ]),
    ]),
    _c(
      "div",
      { staticClass: "questionnaireEditTableContainer", class: _vm.classes },
      [
        !_vm.preview && _vm.isSelected === "checked" && _vm.template.actions
          ? _c("div", [
              _c(
                "button",
                {
                  staticClass: "rb-buttons small main",
                  on: {
                    click: function ($event) {
                      return _vm.configureTable()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("grid_on"),
                  ]),
                  _vm._v(" Configure "),
                ]
              ),
            ])
          : _vm._e(),
        _c("div", { staticClass: "layout-row" }, [
          _c("div", { staticClass: "questionnaireEditTableWrapper" }, [
            _c(
              "table",
              { staticClass: "questionnaireEditTable" },
              _vm._l(_vm.cellsToView, function (cell) {
                return _c("questionnaire-table-row", {
                  key: cell.id,
                  attrs: { template: cell, model: _vm.tableConfig },
                })
              }),
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }